<div class="row g-3" appVisible [visible$]="visible$">
  @if ((data$ | async) !== undefined && !loading && !error) {
    @if (message) {
      <div class="col-12 py-3">
        <div class="d-flex align-items-center justify-content-center w-100">
          <div class="info-overlay border rounded p-3 text-center">
            <span>{{ message }}</span>
          </div>
        </div>
      </div>
    }
    @for (card of climateData; track card.entityId) {
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <app-card>
          <div class="room-card w-100">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="w-100">
                <div class="title d-flex justify-content-between">
                  <h5>{{ card.name }}</h5>
                  <a
                    [routerLink]="['/klimaat']"
                    [queryParams]="{
                      objecten: card.entityId,
                      periode: 'live',
                    }"
                  >
                    <i class="bi bi-graph-up-arrow ms-2 text-primary" title="Bekijk grafiek"></i>
                  </a>
                </div>
                <small class="text-muted">{{ card.path }}</small>
              </div>
            </div>

            @for (metric of card.metrics; track metric.type) {
              <div class="metric-row">
                <div class="metric-icon" [class]="metric.type | appClimateIconClass">
                  <i class="bi" [class]="metric.type | appClimateIcon"></i>
                </div>
                <div class="metric-content">
                  <p class="metric-label">{{ metric.label }}</p>
                  <p class="metric-value">{{ metric.value }} {{ metric.unit }}</p>
                </div>

                @if (showBadges) {
                  <span [innerHTML]="metric.status | appClimateBadge"></span>
                }
              </div>
            }
          </div>
        </app-card>
      </div>
    }
  }
  @if (loading && !message) {
    @for (i of [].constructor(3); track $index) {
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <app-card>
          <div class="room-card w-100">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="w-100">
                <div class="title d-flex justify-content-between">
                  <h5 class="placeholder">placeholder voor asset maam</h5>
                </div>
                <span class="placeholder">placeholder</span>
              </div>
            </div>

            <div class="metric-row">
              <div class="metric-icon icon-temp">
                <i class="bi bi-thermometer-half"></i>
              </div>
              <div class="metric-content">
                <p class="metric-label placeholder">placeholder</p>
                <p class="metric-value placeholder">placeholder</p>
              </div>

              <span class="placeholder">placeholder</span>
            </div>

            <div class="metric-row">
              <div class="metric-icon icon-humidity">
                <i class="bi bi-droplet"></i>
              </div>
              <div class="metric-content">
                <p class="metric-label placeholder">placeholder</p>
                <p class="metric-value placeholder">placeholder</p>
              </div>
              <span class="placeholder">placeholder</span>
            </div>

            <div class="metric-row">
              <div class="metric-icon icon-co2">
                <i class="bi bi-wind"></i>
              </div>
              <div class="metric-content">
                <p class="metric-label placeholder">placeholder</p>
                <p class="metric-value placeholder">placeholder</p>
              </div>
              <span class="placeholder">placeholder</span>
            </div>
          </div>
        </app-card>
      </div>
    }
  }
</div>
